import { trackError } from '@billy/track-error'

import type { Contact } from '@features/contacts/types/contact'
import { findContactsWithBohr } from '@modules-deprecated/app/contacts'
import { ChartOfAccountId } from '@modules-deprecated/app/organization/enums/chartOfAccountId'
import type { BankLine } from '@modules-deprecated/bankReconciliation/types'
import type { BillFormPartial } from '@views/bills/elements/BillEditableForm/utils/formData'
import { getBookkeepingTagSuggestionsFromDescription } from '@views/bills/elements/BillEditableForm/utils/getBookkeepingTagSuggestionsFromDescription'

import { LocaleIdentifier } from '../../../../../../../../../types/localeIdentifier'
import { getLocalDateFromDateString } from '../../../../../../../../../utils/getLocalDateFromDateString'

interface GetBillFormFromBankTransactionProps {
  chartOfAccountId?: ChartOfAccountId
  currency?: string
  locale: string
  organizationCountryCode?: string
  organizationId: string
  transaction: BankLine
  userId?: string
  userLocale?: LocaleIdentifier
}

const getVendor = async (organizationId: string, name: string): Promise<Partial<Contact> | undefined> => {
  if (!name?.trim()) {
    return undefined
  }

  try {
    const vendors = await findContactsWithBohr(organizationId, name)

    if (vendors.length) {
      return vendors[0]
    }
  } catch (error) {
    trackError(error)
  }

  return { name }
}

export const getBillFormFromBankTransaction = async ({
  chartOfAccountId,
  currency,
  locale,
  organizationCountryCode,
  organizationId,
  transaction,
  userId,
  userLocale,
}: GetBillFormFromBankTransactionProps): Promise<BillFormPartial> => {
  const vendor = await getVendor(organizationId, transaction.description)
  const bookkeepingTagSuggestions = await getBookkeepingTagSuggestionsFromDescription({
    chartOfAccountId,
    contact: vendor,
    description: transaction.description,
    locale,
    organizationCountryCode,
    organizationId,
    userId,
    userLocale,
  })

  return {
    billDate: getLocalDateFromDateString(transaction.entryDate),
    billLines: [
      {
        description: transaction.description,
        inclVatAmount: transaction.amount,
      },
    ],
    ...(bookkeepingTagSuggestions.length ? { bookkeepingTagSuggestions } : {}),
    currencyId: currency,
    vendor,
  }
}
